import React from 'react'
import AboutUsSection from './AboutUsSection'
import LogoSection from './LogoSection'
import OnlineTherapySection from './OnlineTherapySection'
import ReserveAnHourSection from './ReserveAnHourSection'
import desktopLogo from 'images/landing-v2/desktop_new_logo.svg'
const Footer = ({b2b}) => {
    return (
        <div className='footer-container'>
            <div className="footer-sections-container">
                <LogoSection desktopLogo={desktopLogo} b2b={b2b}/>
                <AboutUsSection/>
                <OnlineTherapySection/>
                <ReserveAnHourSection/>
            </div>
            <p className='company-text'>© 2023 Terapi</p>
        </div>
    )
}

export default Footer
